import { render, staticRenderFns } from "./AlertArea.vue?vue&type=template&id=e643ab28&"
import script from "./AlertArea.vue?vue&type=script&lang=js&"
export * from "./AlertArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports